const initialState = {
  events: [],
  permissionFlags: null,
  pages: [],
  collections: [],
  inMemoryCollections: [],
  snippets: [],
  plugins: [],
  dataSources: [],
  projectDetail: null,
  showCreateEvent: false,
  defaultPage: null,
  isOpenActionPropModal: false,
  isOpenActionEnableModal: false,
  selectedAction: null,
  selectedEvent: null,
  pageContent: null,
  isOpenEventUpdateModel: false,
  loadEventsPending: false,
  loadEventsError: null,
  loadEventDetailPending: false,
  loadEventDetailError: null,
  loadPageContentPending: false,
  loadPageContentError: null,
  loadPagesInEventPending: false,
  loadPagesInEventError: null,
  loadDefaultPagePending: false,
  loadDefaultPageError: null,
  loadCollectionsInEventPending: false,
  loadCollectionsInEventError: null,
  loadSnippetsInEventPending: false,
  loadSnippetsInEventError: null,
  deleteActionPending: false,
  deleteActionError: null,
  deleteEventPending: false,
  deleteEventError: null,
  saveNewActionPending: false,
  saveNewActionError: null,
  saveNewEventPending: false,
  saveNewEventError: null,
  updateActionPending: false,
  updateActionError: null,
  updateEventPending: false,
  updateEventError: null,
  loadProjectPending: false,
  loadProjectError: null,
  loadInMemoryCollectionPending: false,
  loadInMemoryCollectionError: null,
  loadProjectPluginsPending: false,
  loadProjectPluginsError: null,
  swapActionStepPending: false,
  swapActionStepError: null,
  enableActionPending: false,
  enableActionError: null,
  loadProjectDetailEventPending: false,
  loadProjectDetailEventError: null,
  loadDatasourcesInEventPending: false,
  loadDatasourcesInEventError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
};

export default initialState;
